import styled, { css } from "styled-components"
import PropTypes from "prop-types"

import ChevronDown from "../../images/chevron-down-small.svg"

export const Input = styled.input`
  position: relative;
  width: 100%;
  padding: 12px 8px;
  margin: 8px 0 11px;
  font-size: 18px;
  border: 1px solid ${props => props.theme.colors.baseGrey};
  ${({ error }) =>
    error &&
    css`
      border-color: ${props => props.theme.colors.coral};
    `};

  border-radius: 4px;
  height: 48px;

  ${props =>
    props.left &&
    css`
      border-radius: 3px 0 0 3px;
    `};

  ${props =>
    props.right &&
    css`
      border-radius: 0 3px 3px 0;
      width: calc(100% + 1px);
      margin-left: -1px;
    `};

  ${props =>
    props.large &&
    css`
      padding: 30px 16px;
      font-size: 22px;
    `};

  :focus {
    border-color: ${props => props.theme.colors.black};
    outline: 0;
    z-index: 1;
  }
`
Input.propTypes = {
  large: PropTypes.bool,
  left: PropTypes.bool,
  right: PropTypes.bool,
}

// export const Checkbox = styled.

export const Label = styled.label`
  display: block;
  flex: 1;
  font-size: 14px;
  text-align: left;
  color: ${props => props.theme.colors.darkGrey};
  //text-indent: 8px;
  text-transform: ${props => (props.noCaps ? `none` : `uppercase`)};
  line-height: 1;
`
const LabelPropTypes = {
  noCaps: PropTypes.bool,
}

Label.propTypes = LabelPropTypes

export const RadioLabel = styled(Label)`
  color: #000;
  font-size: 16px;
  margin-bottom: 4px;

  input[type="radio"] {
    margin-right: 8px;
  }
`
RadioLabel.propTypes = LabelPropTypes

export const Select = styled.select`
  appearance: none;
  position: relative;
  width: 100%;
  padding: 4px 8px;
  margin: 8px 0 11px;
  border: 1px solid ${props => props.theme.colors.baseGrey};
  font-size: ${props => (props.small ? "16px" : "18px")};

  ${({ error }) =>
    error &&
    css`
      border-color: ${props => props.theme.colors.coral};
    `};

  border-radius: 4px;
  background-color: #ffffff;
  background-image: url(${ChevronDown});
  background-origin: content-box;
  background-position: right 8px center;
  background-repeat: no-repeat;
  background-size: 9px;
  font-weight: 400;

  :focus {
    border-color: ${props => props.theme.colors.baseGrey};
    z-index: 1;
  }
`

Select.propTypes = {
  small: PropTypes.bool,
}

export const ValidationError = styled.div`
  text-transform: none;
  text-indent: 0;
  margin: -12px 0 8px;
  padding: 5px 0;
  color: ${props => props.theme.colors.coral};
  font-size: 14px;
`
